export enum TisCalculationOperator {
    SUBTRACT = 'SUBTRACT'
}
